import * as types from "../actions/actionTypes";

const initialState = {
  offers: [],
  offer: null,
};

const offer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_OFFER_RESPONSE: return { ...state, offers: action.payload };
    case types.GET_OFFER_RESPONSE: return { ...state, offer: action.payload };

    case types.CREATE_OFFER: return { ...state, offer: null };
    case types.UPDATE_OFFER: return { ...state, offer: null };
    case types.DELETE_OFFER: return { ...state, offer: null };
    default:
      return state;
  }
};

export default offer;
